import { $api } from "../../../../services/request.config";
import { GET_INDIVIDUAL_COEFFICIENTS_DRAFT } from "../../../../enums/Request/individualCoefficients.types";

import IndividualCoefficientsService from "../../../../../frontend.services/LeaderRequests/IndividualCoefficientsService";

export const getIndividualCoefficientThunkAction = (uid) => async (dispatch) => {
    try {
        const response = await $api(`v1/managers/requests/individual-coefficients/${uid}`);
        if (!IndividualCoefficientsService.isValidRequestResponse(response.data, uid)) {
            return {
                ok: false,
                error: { kind: "integration", message: "Сервер вернул некорректный ответ. Попробуйте ещё раз." },
            };
        }
        dispatch({ type: GET_INDIVIDUAL_COEFFICIENTS_DRAFT, payload: response.data });
        return { ok: true, data: response.data };
    } catch (error) {
        return { ok: false, error: IndividualCoefficientsService.classifyError(error) };
    }
};